import { gql } from 'apollo-client-ppc';

export const fetchOfferingsAndAvailablePricingPlans = gql`
  query fetchOfferingsAndAvailablePricingPlans(
    $id: ID!
    $pricingPlanFilterOptions: [FilterOption]
    $includeExperimentalProducts: Boolean
  ) {
    nativeCatalogItem: partnerNativeCatalogItem(id: $id, includeExperimentalProducts: $includeExperimentalProducts) {
      id
      offering {
        id
        offeringName
        pricingType
        trialLengthInDays
        offeringGroup
        relationshipRequirements {
          level
          side
          type
        }
        availableAddOns {
          offeringId
          name
        }
        chargeElements {
          type
          data {
            ceiling
          }
        }
        availablePricingPlans(filterOptions: $pricingPlanFilterOptions) {
          type
          billingFrequency
          updatedAt
          id
          currency
          pricingPlanType
          status
          description
          tiers {
            floor
            ceiling
            amount
            unitAmount
            flatAmount
          }
        }
      }
    }
  }
`;
